import { Component, Input, OnInit } from "@angular/core";

import { Notification } from "../../models/notification.model";
import { UrlBuilderService } from "../../services/url-builder.service";
import { TextAvatarPipe } from "../../shared/pipes/text-avatar.pipe";
import { UserNotificationsService } from "../../services/user-notifications.service";
import { User } from "../../models/user.model";
import { TranslateModule } from "@ngx-translate/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MessagesService } from "../../shared/services/messages.service";
import { NgStyle } from "@angular/common";
import { TimeAgoPipe } from "../../shared/pipes/timeago.pipe";
import { InfiniteScrollComponent } from "../../shared/infinte-scroll/infinite-scroll.component";
import { Router } from "@angular/router";

@Component({
  selector: "notification-dialog",
  standalone: true,
  imports: [TextAvatarPipe, TranslateModule, MatProgressSpinner, NgStyle, TimeAgoPipe, InfiniteScrollComponent],
  templateUrl: "./notification-dialog.component.html",
  styleUrl: "./notification-dialog.component.scss",
})
export class NotificationDialogComponent implements OnInit {

  @Input()
  user: User

  notifications: Notification[];

  loadingNotifications: boolean = false;

  emptyNotifyImgUrl: string;
  private displayEmptyState: boolean;

  isLoading: boolean = false;

  hasMore: boolean = false;
  private NOTIFICATIONS_PAGE_SIZE: number = 10;

  constructor(private ub: UrlBuilderService,
              private userNotificationsService: UserNotificationsService,
              private messages: MessagesService,
              private router: Router
  ) {}

  async ngOnInit() {
    this.emptyNotifyImgUrl = this.ub.buildImageUrl("/images/common/empty-notification.png");

    this.loadingNotifications = true;

     this.notifications = await this.userNotificationsService.loadNotificationsPage(this.NOTIFICATIONS_PAGE_SIZE, this.user.id)
    console.log("Notifications loaded: ", this.notifications)
    this.loadingNotifications = false;

  }

  markAllAsRead() {
    const origNotifications = [...this.notifications]

    this.notifications = this.notifications.map(notification => {
      if(notification.read) return notification

      return {...notification, read: true}
    })

    this.userNotificationsService.markAllAsRead(this.notifications).then(() => {
      this.messages.success("")
    }).catch(error => {
      this.messages.error(error)
      this.notifications = origNotifications
    })

  }

  async loadMoreNotifications(notifications: Notification[]) {

    try {

      console.log('loading more notifications', [...notifications]);

      this.isLoading = true;
      this.hasMore = true;

      const lastNotification = notifications[notifications?.length - 1];
      if (!lastNotification) {
        return
      }

      let newNotifications = await this.userNotificationsService.loadNotificationsPage(this.NOTIFICATIONS_PAGE_SIZE, this.user.id, lastNotification.createdAt);

      this.hasMore = newNotifications.length !== 0;

      this.notifications = [...notifications, ...newNotifications];

      this.displayEmptyState = this.notifications.length <= 0;

    } catch (err) {

      console.log('error loading more notifications', err);

    } finally {

      this.isLoading = false;
      // this.loading.loadingOff();

    }
  }

  async navigateToPostPage(item: Notification) {

    if(!item.postId || item.actionType === 'like') return

    if (item.actionType === 'comment' || item.actionType === 'reply') {

      this.notifications = this.notifications.map(notification => {
        if (notification.id === item.id) {
          return { ...notification, read: true }
        } else {
          return notification
        }
      })

      await this.userNotificationsService.markAsRead(this.notifications.find(notification => notification.id === item.id))

      // navigate to community/posts/Z89NoyduIKVNyAT3vBbO?prv=%2Fcommunity%2Fhome

      const url = `/community/posts/${item.postId}?prv=%2Fcommunity%2Fhome`

      await this.router.navigateByUrl(url);

    }
  }

  isAllRead() {
    return this.notifications?.every(notification => notification?.read)
  }
}
